<template lang="pug">
  span.lds--container
    template(v-if="shown")
      .lds-ellipsis
        div(:class="`bg_${color}`")
        div(:class="`bg_${color}`")
        div(:class="`bg_${color}`")
        div(:class="`bg_${color}`")
</template>



<script>
  export default  {
    props: {
      shown: {
        type: Boolean,
        default: true,
      },
      color: {
        type: String,
        default: 'secondary',
      }
    },

    data() {
      return {

      }
    },


    computed: {

    },


    methods: {

    },


    created() {

    }
  }
</script>




<style lang="scss">
.lds--container {
  display: inline-block;
  line-height: 1;
  position: relative;
  top: 8px;
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 16px;
  transform: scale(0.8);
}
.lds-ellipsis div {
  position: absolute;
  top: 0px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  
  animation-timing-function: cubic-bezier(0, 1, 1, 0);

  &.bg_primary {
    background: $color-primary;
  }
  &.bg_primary_light {
    background: $color-primary_light;
  }
  &.bg_secondary {
    background: $color-secondary;
  }
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}

</style>